module.exports = __webpack_public_path__ + "static/img/landing-min.7e27e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing-min.jpg
// module id = 7YbF
// module chunks = 1